import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import { trackGroupAdded } from "../analytics";
import { entityCache } from "../sync/entity-cache";
import {
  CreateGroupRequest,
  CreateGroupResponse,
  EditGroupRequest,
  DeleteGroupRequest,
  StandardResponse,
  GetMyGroupsRequest,
  GetMyGroupsResponse,
  GetGroupRequest,
  GetGroupResponse,
  GetAllGroupsRequest,
  GetAllGroupsResponse,
  AddContactToGroupRequest,
  RemoveContactFromGroupRequest,
} from "common247";

export async function getAllGroups(fb: FirebaseServices, request: GetAllGroupsRequest): Promise<GetAllGroupsResponse> {
  const result = await callFunction(fb, "getAllGroupsFunc", request);
  return result as GetAllGroupsResponse;
}

export async function createGroup(fb: FirebaseServices, request: CreateGroupRequest): Promise<CreateGroupResponse> {
  const result = (await callFunction(fb, "createGroupFunc", request)) as CreateGroupResponse;
  if (result && (result as any).status !== false) {
    trackGroupAdded((result as any).id || "group", request.name);
  }
  return result as CreateGroupResponse;
}

export async function editGroup(fb: FirebaseServices, request: EditGroupRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "editGroupFunc", request);
  return result as StandardResponse;
}

export async function deleteGroup(fb: FirebaseServices, request: DeleteGroupRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "deleteGroupFunc", request);
  return result as StandardResponse;
}

export async function getMyGroups(fb: FirebaseServices, request: GetMyGroupsRequest): Promise<GetMyGroupsResponse> {
  const result = (await callFunction(fb, "getMyGroupsFunc", request)) as GetMyGroupsResponse;
  if (result && Array.isArray(result.groups)) {
    entityCache.setCachedList("group", result.groups, "myGroups");
  }
  return result;
}

/**
 * Retrieves a single group by ID.
 *
 * @param {FirebaseServices} fb - The Firebase services instance.
 * @param {GetGroupRequest} request - The request containing groupId.
 * @returns {Promise<GetGroupResponse>} The retrieved group response.
 */
export async function getGroup(fb: FirebaseServices, request: GetGroupRequest): Promise<GetGroupResponse> {
  const result = await callFunction(fb, "getGroupFunc", request);
  return result as GetGroupResponse;
}

export async function addContactToGroup(fb: FirebaseServices, request: AddContactToGroupRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "addContactToGroupFunc", request);
  return result as StandardResponse;
}

export async function removeContactFromGroup(fb: FirebaseServices, request: RemoveContactFromGroupRequest): Promise<StandardResponse> {
  const result = await callFunction(fb, "removeContactFromGroupFunc", request);
  return result as StandardResponse;
}
